export function formatDateOnlyLocal(value) {
  if (!value) return '';

  if (typeof value === 'string') {
    // akzeptiere sowohl YYYY-MM-DD als auch ISO-Timestamps
    return value.includes('T') ? value.split('T')[0] : value;
  }

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function todayDateOnlyLocal() {
  return formatDateOnlyLocal(new Date());
}
